import type { Automation } from '../types/automation.types';

/**
 * Default automation template used when creating new automations
 * This ensures consistency across the application
 */
export const DEFAULT_AUTOMATION_DATA: Omit<Automation, 'automation_id' | 'user_id' | 'created_at'> = {
    type: 'instagram',
    status: 'draft',
    data: {
        trigger: {
            source: 'all',
            action: 'keyword',
            data: {
                keywords: 'link',
            },
            media_ids: [],
        },
        response: {
            type: 'message',
            data: {
                content: "Hi, thanks for reaching out! 👋\nHere's the link to access my store.\n<user_store_url>",
                buttons: [],
            },
            comment_choices: [],
        },
    },
    analytics: {
        sent: 0,
    },
};
